import { render, staticRenderFns } from "./notifications-side-bar.vue?vue&type=template&id=123fd86c"
import script from "./notifications-side-bar.vue?vue&type=script&lang=js"
export * from "./notifications-side-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports